import { Component, OnInit, Output, EventEmitter} from '@angular/core';
import { BackendService } from '../../core/backend.service';
import { Cliente } from '../cliente.model';
import { ActivatedRoute, Router } from '@angular/router';
import { NavigationService } from '../../shared-services/navigation.service';
import { SnackService } from '../../shared-services/snack.service';
import { DialogService } from '../../shared-components/modals/dialog.service';
import { EstadoCliente } from '../estadoCliente.model';
import { TelefonoCliente } from '../telefonoCliente.model';
import { EmailCliente } from '../emailCliente.model';
import { ClienteService } from '../../core/cliente.service';
import { MotivosRechazo } from '../motivosRechazo/motivosRechazo.model';
import { AprobacionCliente } from '../../shared-components/validar-documentacion/aprobacionCliente.model';
import { Acuerdo } from '../../acuerdo/acuerdo.model';
import { Observable } from 'rxjs/Observable';
import { Subcliente } from '../subcliente.model';

import{ CsvmapperService } from '../../shared-services/csvmapperService';
import{ AcuerdosExcel } from './models/acuerdosExcel';

//import { ExcelDto } from './models/excelDto.model'





interface Filters {
  page: number;
  size: number;
  search?: string;
  sort?: string;
}

interface Page {
  pageIndex: number;
  pageSize: number;
}

@Component({
  selector: 'app-cliente-details',
  templateUrl: './cliente-details.component.html',
  styleUrls: ['./cliente-details.component.scss']
})
export class ClienteDetailsComponent implements OnInit {


  showButtons = false;
  private descargaDocumentacion = document.createElement('a');
  cliente: any;
  acuerdos: Observable<Acuerdo[]>;

  EstadoCliente = new EstadoCliente();
  private aprobFlag = false;
  private TelefonoCliente = new TelefonoCliente();
  private EmailCliente = new EmailCliente();
  private motivosRechazo: MotivosRechazo[];
  private motivosRechazoSeleccionados: Number[];
  private observacion: string;
  private linkReenvio: {id: number, description: string};
  private validacion: AprobacionCliente;

  //private datosExcel : ExcelDto;

  title = "DowloadFile";



  subclientes: Subcliente[] = [];

  private acuerdosFilters: Filters = {
    page: 0,
    size: 3,
    sort: 'estado.id,fechaHasta'
  };
  totalAcuerdos: any;
  newTipoUsuario: number;

  constructor(
    private route: ActivatedRoute,
    public router: Router,
    private backendService: BackendService,
    private snackService: SnackService,
    private dialogService: DialogService,
    private csvMapper: CsvmapperService,
    clienteService: ClienteService,


  ) { }

  async ngOnInit() {
    this.route.data.subscribe(data => {
      this.cliente = data.cliente;
      this.cliente.motivosRechazoId = [];


      if (data.cliente.motivoRechazo) {
        this.observacion = data.cliente.motivoRechazo;
      }else {
        this.observacion = '';
      }
    });
    await this.getSubclientes();
    for (const telefono of this.cliente.telefonos) {
      switch (telefono.tipoTelefonoId) {
        case this.TelefonoCliente.staticParticular:
          telefono.icono = 'phone';
          telefono.description = this.TelefonoCliente.staticDescParticular;
          break;
        case this.TelefonoCliente.staticCelular:
          telefono.icono = 'phone_android';
          telefono.description = this.TelefonoCliente.staticDescCelular;
          break;
        case this.TelefonoCliente.staticLaboral:
          telefono.icono = 'phonelink_ring';
          telefono.description = this.TelefonoCliente.staticDescLaboral;
          break;
        default:
          telefono.icono = 'phone';
          telefono.description = 'Teléfono';
      }

    }
    for (const email of this.cliente.emails) {
      switch (email.tipoEmailId) {
        case this.EmailCliente.staticPersonal:
          email.icono = 'contact_mail';
          email.description = this.EmailCliente.staticDescPersonal;
          break;
        case this.EmailCliente.staticLaboral:
          email.icono = 'email';
          email.description = this.EmailCliente.staticDescLaboral;
          break;
        default:
          email.icono = 'email';
          email.description = 'Email';
      }

      this.getAcuerdosComerciales();
    }

  }

  async confirmAprobar() {
    /*
    if (this.validateAprob()) {
        this.dialogService.confirm('Aprobar Cliente',
        '¿Está seguro que desea aprobar el cliente ' + this.cliente.name + ' ' + this.cliente.lastname + '?')
        .then( res => {
          if (res) {
            this.aprobar(res);
          }
        });
    }*/
    this.router.navigate(['/clientes/validar-documentacion/' + this.cliente.id]);
  }

  /*
  async confirmRechazar() {

        await this.getMotivosRechazo();

        this.dialogService.rechazarCliente('Rechazar Cliente',
        '¿Está seguro que desea bloquear al usuario?' + this.cliente.name + ' ' + this.cliente.lastname , this.motivosRechazo )
        .then( res => {
          if (res) {
            this.rechazar(res);
          }
        });

  }*/

  async confirmRehabilitar() {

        this.dialogService.confirm('Rehabilitar Cliente',
        '¿Está seguro que desea rehabilitar el cliente ' + this.cliente.name + ' ' + this.cliente.lastname + '?')
        .then( res => {
          if (res) {
            this.rehabilitar(res);
          }
        });

  }

  async aprobarRechazarCliente() {
    this.snackService.spinner(true);
    try {
      this.cliente.motivoRechazo = 'Rechazado';
      this.cliente.motivosRechazoId = [];
      await this.backendService.create(Cliente.path + 'aprobar_rechazar/' + this.cliente.id, this.cliente ) ;
      this.router.navigate(['/clientes/detalles/' + this.cliente.id]);
      this.snackService.success('Cliente rechazado satisfactoriamente');
    } catch (ex) {
      if (ex[0]) {
        this.snackService.error(ex[0].details);
      } else if (ex.errors) {
        this.snackService.error(ex.errors[0].defaultMessage);
      } else {
        this.snackService.error(ex.message);
      }
    } finally {
      this.snackService.spinner(false);
    }
  }

  async rechazar(res) {
    if (res) {

      this.snackService.spinner(true);

      try {

        this.cliente.motivosRechazoId = res[0];
        this.cliente.observacion = res[1];
        await this.backendService.create(Cliente.path + 'rechazar/' + this.cliente.id, this.cliente);
        this.snackService.success('Cliente rechazado');
        this.cliente.estado.id = 6;
        this.cliente.enable = false;
        this.cliente.estado.description = 'Rechazado';
        this.cliente.motivoRechazo = res[1];
        this.cliente.motivosRechazo = res[2];
      } catch (ex) {
        this.snackService.error(ex.message);
      } finally {
        this.snackService.spinner(false);
      }
    }
  }

  async rehabilitar(res) {
    if (res) {

      this.snackService.spinner(true);

      try {
        await this.backendService.create(Cliente.path + 'rehabilitar/' + this.cliente.id, null);
        this.snackService.success('Cliente rehabilitado');
        this.cliente.enable = true;
      } catch (ex) {
        this.snackService.error(ex.message);
      } finally {
        this.snackService.spinner(false);
      }
    }
  }

  async confirmRestablecer(id) {
    this.dialogService.confirm('Restablecer Contraseña',
    '¿Está seguro que desea restablecer la contraseña del cliente?')
    .then( res => {
      if (res) {
        this.restablecer(res, id);
      }
    });
  }

  async confirmReenvioEmail() {
    this.dialogService.confirm('Reenviar Email de Confirmación',
    '¿Está seguro que desea reenviar el email de confirmación al cliente?')
    .then( res => {
      if (res) {
        this.reenviarEmail(res);
      }
    });
  }

  async confirmDelete(id) {
    this.dialogService.confirm('Eliminar cliente',
    '¿Está seguro que desea eliminar el cliente?')
    .then( res => {
      if (res) {
        this.eliminarNuevo(res, id);
      }
    });
  }

  editar(id: number) {
    this.router.navigate(['/clientes/editar', id]);
  }

  editarSubcliente(id: number) {

    this.router.navigate(['/clientes/editar-usuario/' , id]);
  }

  async getMotivosRechazo() {
      this.motivosRechazo = await this.backendService.get(MotivosRechazo, Cliente.path + 'motivosrechazos/all', null).toPromise();
  }

  async getAcuerdosComerciales() {
    this.acuerdosFilters.search = 'cliente.id:' + this.cliente.id;
    this.backendService.get(Acuerdo, Acuerdo.path, this.acuerdosFilters).toPromise().then(v => {
      this.acuerdos = Observable.of(v);
      this.totalAcuerdos = v['totalItems'];
    });
  }

  async getSubclientes() {
    await this.backendService.get(Subcliente, Subcliente.path + 'all/' + this.cliente.id, null).toPromise().then(value => {
       this.subclientes = value as Subcliente[];
    });
  }


  async getDocumentacion() {
  }

  private openWindow(data) {
    try {
      const blob = new Blob([data], { type: 'application/zip' });
      this.descargaDocumentacion.href = window.URL.createObjectURL(blob);
      this.descargaDocumentacion.download = this.cliente.name || this.cliente.lastname ?
        this.cliente.name + '_' + this.cliente.lastname + '.zip' : this.cliente.emails[0].direccion + '.zip';
      this.descargaDocumentacion.click();
    } catch (ex) {
      console.log(ex);
    }
  }

  async restablecer(res, id) {
    if (res) {

      this.snackService.spinner(true);
      try {
        await this.backendService.resetPassword('/subclientes/reset_password?id=' + id, Cliente);
        this.snackService.success('Contraseña reestablecida correctamente');
      } catch (ex) {
        this.snackService.error(ex.message);
      } finally {
        this.snackService.spinner(false);
      }
    }
  }

  async eliminar(res, id) {
    if (res) {

      this.snackService.spinner(true);
      try {
        await this.backendService.delete(Subcliente.path + id);
        this.snackService.success('Usuario eliminado correctamente');
        this.getSubclientes();
      } catch (ex) {
        this.snackService.error(ex.message);
      } finally {
        this.snackService.spinner(false);
      }
    }
  }

  async eliminarNuevo(res, id){
    if (res) {

      this.snackService.spinner(true);
      try {
        await this.backendService.delete("/clientes/" + id);
        this.snackService.success('Cliente eliminado correctamente');
      } catch (ex) {
        this.snackService.error(ex.message);
      } finally {
        this.snackService.spinner(false);
        this.router.navigate(['/clientes']);
      }
    }
  }

  async reenviarEmail(res) {
    if (res) {

      this.snackService.spinner(true);
      try {
        await this.backendService.resendEmail('/clientes/resend_email?id=' + this.cliente.id, Cliente);
        this.snackService.success('Email de confirmación reenviado correctamente');
      } catch (ex) {
        this.snackService.error(ex.message);
      } finally {
        this.snackService.spinner(false);
      }
    }
  }

  validateAprob() {
    if (!this.cliente.montoCompraActual && !this.aprobFlag) {
      this.snackService.error('Primero debe asignarle un monto límite de compra al cliente');
      return false;
    }
    if (this.cliente.estado.id !== EstadoCliente.PendAprobacion) {
      this.snackService.error('El cliente no se encuentra en condiciones para ser aprobado');
      return false;
    }
    return true;
  }

  async aprobar(res) {
    if (res) {

      this.snackService.spinner(true);

      try {
        await this.backendService.create(Cliente.path + 'aprobar/' + this.cliente.id, null);
        this.snackService.success('Cliente aprobado');
        this.cliente.estado.id = 4;
        this.cliente.estado.description = 'Aprobado';
      } catch (ex) {
        this.snackService.error(ex.message);
      } finally {
        this.snackService.spinner(false);
      }
    }
  }

  async confirmLinkReenvio() {
    this.snackService.spinner(true);

    await this.backendService.getLinkReenvio('/clientes/get_link_reenvio?id=' + this.cliente.id)
    .then(res  => {
      this.linkReenvio = res as {id: number, description: string};
    });

    this.snackService.spinner(false);
    this.dialogService.getLinkReenvio(this.linkReenvio.description);
  }

  onAddUsuario(id) {
    this.router.navigate(['/clientes/agregar-usuario/' + id]);
  }

  mostrarAcuerdo(acuerdoId: number) {
    this.router.navigateByUrl('/acuerdos/detalles/' + acuerdoId);
  }

  onPageAcuerdoChange(page: Page) {
    this.acuerdosFilters.page = page.pageIndex;
    this.acuerdosFilters.size = page.pageSize;
    this.getAcuerdosComerciales();
  }

  async onSubclienteEnableChange(subcliente: Subcliente, event: any) {
    this.snackService.spinner(true);

    try {
      await this.backendService.update(Subcliente.path + 'actualizar-estado/' + subcliente.id, subcliente);
      this.snackService.success('Subcliente modificado');
    } catch (ex) {
      console.log(ex);
      subcliente.enable = !subcliente.enable;
      this.snackService.error('No se pudo modificar el estado del subcliente');
    } finally {
      this.snackService.spinner(false);
    }
  }



/* Logica del Boton Descarga de reportes*/

  descargaDeReportes(url: String, nombreArchivo: any): void{
    /*
    this.datosExcel.clienteId = this.cliente.id;
    this.datosExcel.acuerdoId = acuerdo;
    */
    console.log('Descargando Reporte');

    let listaAcuerdo;

    const fileName = nombreArchivo;

    //this.backendService.put("/report/" + this.cliente.id + url)

     this.backendService.getBoolean("/report/" + this.cliente.id+ url).then(a => {
       listaAcuerdo = a as AcuerdosExcel[];
       this.csvMapper.map(listaAcuerdo, fileName);
       });

  }

  descargaTotalReportes(acuerdo: Number): void{
    this.descargaDeReportes("/1/",`Reporte_Datos_Acuerdos_Cliente_${this.cliente.id}`);
    this.descargaDeReportes("/2/", `Reporte_Cantidad_Productos_Cliente_${this.cliente.id}`);
  }

  onTipoUsuarioChange(newTipo: number) {
    console.log(newTipo);
    this.showButtons = true;
    this.newTipoUsuario = newTipo; 
  } 

  close () {
    this.showButtons = false;
  }
  
  async guardar () {

    try {
      this.snackService.spinner(true);
      await this.backendService.update(Cliente.path + "change-tipo-usuario/" + this.cliente.id + "/" + this.newTipoUsuario, null);
      this.snackService.success('Tipo de usuario modificado corecctamente');
      //this.router.navigate(['/notificaciones']);
    } catch (ex) {
      this.snackService.spinner(false);
      this.snackService.error(ex.message);
    } finally {
      this.snackService.spinner(false);
    }
    
  }

}



// WEBPACK FOOTER //
// ./src/app/cliente/cliente-details/cliente-details.component.ts